import AppDispatcher from "../Dispatcher";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";

const basePath = AppConfig.getBookApiBasePath();

export const fetchParentData = (filters, campaignUniqueIdCode, packageId, auditLevelID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return fetchWithAuthGet(
		`${basePath.ApiBasePath}/plook/Package/GetSelectedParentMetaData/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${filters.platform.value}/${auditLevelID}/${campaignUniqueIdCode}/${packageId}`
	).then((response) => {
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchParentData, // "FETCHPARENTDATA"
			value: response
		});
	});
};
